<template>
  <span class="va-pro-badge">PRO</span>
</template>

<style>
.va-pro-badge {
  display: inline-block;
  flex: none;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1;
  color: #193153;
  background: #f5f6fa;
  border: 1px solid #e3e6ec;
  border-radius: 999px;
  padding: 3px 7px;
}
</style>

<script>
export default {
  name: "ProBadge",
};
</script>
